<template>
  <div class="content">

    <user-source-list></user-source-list>
    <user-source-create></user-source-create>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import {API} from '../services';
  import UserSourceList from "../components/UserSources/UserSourceList.vue";
  import UserSourceCreate from "../components/UserSources/UserSourceCreate.vue";

  export default {
    name: 'UserSource',
    components: {
      UserSourceList,
      UserSourceCreate
    },
    computed: {
        ...mapGetters(["get_sources"]),
    },
  };
</script>
